import { useEffect, useMemo } from "react";
import { RaRecord, required, SelectArrayInput, useGetOne } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

import { SiteResourcesEnum } from "shared/enums/resourceMappings";

interface Site extends RaRecord {
  id: number;
  name: string;
}

const CertificationRtePhase2SiteIdsInput = () => {
  const { setValue } = useFormContext();
  const edr_id = useWatch({ name: "edr_id" });
  const { data: edr } = useGetOne(SiteResourcesEnum.Groups, { id: edr_id });
  const disabled = !edr_id || !edr || !edr.sites.length;
  const choices = useMemo(() => edr?.sites.map((site: Site) => ({ id: site.id, name: site.name })), [edr]);

  useEffect(() => {
    if (edr) {
      setValue("site_ids", "");
    }
  }, [edr, setValue]);

  return <SelectArrayInput source="site_ids" choices={choices} validate={[required()]} disabled={disabled} />;
};

export default CertificationRtePhase2SiteIdsInput;
